export const toggle = (theme) => ({
    sizes: {
        sm: {
            track: {
                width: '32px',
                height: '16px',
            },
            thumb: {
                size: '12px',
                margin: theme.space?.space2,
                translateX: '16px',
            },
        },
        md: {
            track: {
                width: '48px',
                height: '24px',
            },
            thumb: {
                size: '20px',
                margin: theme.space?.space2,
                translateX: '24px',
            },
        },
    },
    track: {
        default: {
            borderRadius: theme.radii?.full,
            transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        },
        unchecked: {
            backgroundColor: theme.colors?.component?.bold?.default,
        },
        checked: {
            backgroundColor: theme.colors?.component?.brand?.default,
        },
        hover: {
            unchecked: {
                backgroundColor: theme.colors?.component?.bold?.hover,
            },
            checked: {
                backgroundColor: theme.colors?.component?.brand?.hover,
            },
        },
        focus: {
            boxShadow: `0 0 0 2px ${theme.colors?.effects?.focusRing}`,
        },
        disabled: {
            backgroundColor: theme.colors?.component?.disabled,
            cursor: 'not-allowed',
        },
    },
    thumb: {
        default: {
            borderRadius: theme.radii?.full,
            backgroundColor: theme.colors?.surface?.default,
            transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        },
        disabled: {
            backgroundColor: theme.colors?.foreground?.disabled,
        },
    },
    icon: {
        checked: {
            color: theme.colors?.foreground?.inverse,
        },
    },
    label: {
        color: theme.colors?.text?.basic?.primary,
        disabled: {
            color: theme.colors?.text?.basic?.disabled,
        },
    },
});
//# sourceMappingURL=toggle.js.map